import React from 'react'

const CommentsContext = React.createContext({
    username:'',
    comment:''
    
});

export default CommentsContext